module.exports = __webpack_public_path__ + "img/interational_truck_img_2.60d32f5a.png";